import React, { Fragment } from 'react';
import {FormGroup, Input, Label} from "reactstrap";
import {EmailAddress} from "../../../constant";
import Select from 'react-select'
import AsyncSelect from "react-select/async";
import {mapSearchAutoSuggestion} from "../../../utils/mapper";
import {customerAutoSuggestionApi} from "../../../services/order";


const UserForm = (props) => {
    const { errors, control, userRoles, register,setValue,trigger,roles,getValues,watch,currentUser,overridablePermissions } = props;
    // Unrestricted users are outside every override rule, so the block is meaningless for them.
    // Nobody may change their own override (the backend ignores it too).
    const showOverride = !getValues('is_unrestricted');
    const overrideReadOnly = getValues('id') === currentUser.id;
    const overrides = watch('permission_overrides');

    const toggleOverride = (name, checked) => {
        setValue('permission_overrides', checked ? [...overrides, name] : overrides.filter(p => p !== name));
    };

    const customerPromiseOption = (inputValue) =>
        new Promise((resolve) => {
            const data = { value: inputValue };
            setTimeout(() => {
                resolve(mapSearchAutoSuggestion(customerAutoSuggestionApi(data)));
            });
        });
    //const roleRegister = register("role", { required: true });

    return (
        <Fragment>
            <FormGroup>
                <Label className="col-form-label">Name</Label>
                <input name="name" type="text" {...register('name')} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                <div className="invalid-feedback">{errors.name?.message}</div>

            </FormGroup>
            <FormGroup>
                <Label className="col-form-label">{EmailAddress}</Label>
                <input name="email" type="email" {...register('email')} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                <div className="invalid-feedback">{errors.email?.message}</div>

            </FormGroup>
            <FormGroup>
                <Label htmlFor="col-form-label">Role</Label>
                <Select    getOptionLabel ={(option)=>option.name} defaultValue={getValues('role')}
                           getOptionValue ={(option)=>option.id} {...register("role")}    onChange={(e)=>{
                    setValue('role',e);
                    trigger('role');
                }} className={` ${errors.role ? 'is-invalid' : ''}`} options={roles} />

                <div className="invalid-feedback">{errors.role?.message}</div>
            </FormGroup>
            {showOverride && <FormGroup>
                <Label className="col-form-label">Permission override</Label>
                {overridablePermissions.map(name => (
                    <div className="checkbox checkbox-primary" key={name}>
                        <input id={`override_${name}`} type="checkbox" disabled={overrideReadOnly}
                               checked={overrides.includes(name)} onChange={(e) => toggleOverride(name, e.target.checked)}/>
                        <Label for={`override_${name}`} className="col-form-label">{name}</Label>
                    </div>
                ))}
            </FormGroup>}
            {showOverride && overrides.includes('Create Draft Order') && <FormGroup>
                <Label className="col-form-label">Assigned customers</Label>
                <AsyncSelect
                    isMulti
                    isDisabled={overrideReadOnly}
                    cacheOptions
                    defaultOptions
                    defaultValue={getValues('draft_customers')}
                    loadOptions={customerPromiseOption}
                    onChange={(e) => {
                        setValue('draft_customers', e);
                    }}
                />
            </FormGroup>}
        </Fragment>
    );
}

export default UserForm;